<template>
  <div v-if="isMounted">
    <big-title>
      Invertir.
    </big-title>
    <!-- PANEL DE CUMPLIMIENTO -->
    <compliance-banner class="mb-4" @loadedRequirements="loadedRequirements" />
    <!-- SOLO MP -->
    <template v-if="!InvestorRegisteredOnSecondaryMarket">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full">
            <h3>Invierte con impacto</h3>
            <p class="mt-5">Aquí verás las oportunidades de inversión que están disponibles. </p>
            <h3 class="mt-5">Tipos de inversión</h3>
            <!-- iconos para tipos de credito -->
            <div class="mt-base flex flex-wrap items-center flex-grow justify-start">
              <div
                v-for="img in getLoanTypeIcon('all')"
                :key="img.id"
                class="mr-5"
                v-if="img.id !== 0 || InvestorRegisteredOnSecondaryMarket"
              >
                <img style="width: 40px;" :src="img.url" class="center" :alt="img.filename" />
                <small>{{ img.filename }}</small>
              </div>
            </div>
          </div>
          <div class="vx-col w-full">
            <div id="data-list-thumb-view" class="data-list-container mt-4">
              <vs-table class="mt-5" ref="table" @selected="onRowSelected" :data="projectsToInvest" pagination
                :max-items="itemsPerPage" noDataText="No hay oportunidades disponibles">
                <template slot="thead">
                  <vs-th class="bold" sort-key="name">Nombre</vs-th>
                  <vs-th class="bold" sort-key="type"><span class="center">TIPO DE INVERSIÓN</span></vs-th>
                  <vs-th class="bold" sort-key="anual_interest">Tasa</vs-th>
                  <vs-th class="bold">Plazo</vs-th>
                  <vs-th class="bold" sort-key="remaining">Monto disponible</vs-th>
                  <vs-th class="bold">Monto a invertir</vs-th>
                  <vs-th></vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <div class="flex flex-wrap items-center flex-grow justify-start">
                          <p class="pl-3 bold">
                            <router-link v-if="tr.loan_type != 0" class="bold text-dark ml-1 inline-link"
                              :to="{ name: 'oportunidadInversion', params: { id: tr.id } }">
                              {{ tr.name }}
                            </router-link>
                            <span v-else class="text-dark">
                              {{ tr.name }}
                            </span>
                          </p>
                          <template v-if="tr.loan_type == 0">
                            <vx-tooltip color="dark" position="top"
                              :text="tr.investor_id == 1190 ? rgTooltipText : genericTooltipText">
                              <feather-icon class="mt-1 ml-2 cursor-pointer" icon="InfoIcon"
                                svgClasses="h-5 w-5 text-dark" />
                            </vx-tooltip>
                          </template>
                        </div>
                      </vs-td>
                      <vs-td class="center">
                        <vx-tooltip color="dark" position="top" :text="getLoanTypeStr(tr.loan_type, true)">
                          <img :src="getLoanTypeIcon(tr.loan_type)" style="width: 40px" alt="" class="center">
                        </vx-tooltip>
                      </vs-td>
                      <vs-td>
                        <template v-if="tr.loan_type == 0">
                          <vx-tooltip color="dark" position="top"
                            text="Rendimiento anualizado neto promedio de los últimos 12 meses, antes de impuestos.">
                            <div class="flex flex-wrap items-center flex-grow justify-start">
                              <p class="font-medium">{{ tr.anual_interest }}</p>
                              <feather-icon class="ml-2 cursor-pointer" icon="InfoIcon" svgClasses="h-5 w-5 text-dark" />
                            </div>
                          </vx-tooltip>
                        </template>
                        <p v-else class="font-medium">{{ tr.anual_interest }}</p>
                      </vs-td>
                      <vs-td>
                        <template v-if="tr.loan_type == 0">
                          <vx-tooltip color="dark" position="top"
                            :text="'Podrás retirar hasta ' + mxnFormat(maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam) + ' por día, sujeto a la liquidez disponible.'">
                            <div class="flex flex-wrap items-center flex-grow justify-start">
                              <p class="font-medium">{{ tr.months }}</p>
                              <feather-icon class="ml-2 cursor-pointer" icon="InfoIcon" svgClasses="h-5 w-5 text-dark" />
                            </div>
                          </vx-tooltip>
                        </template>
                        <p v-else class="font-medium">{{ tr.months }} Meses</p>
                      </vs-td>
                      <vs-td>
                        <p class="font-medium">{{ tr.remainingFormat }}</p>
                        <vs-progress :percent="Number(tr.progress)" color="success" class="shadow-md" />
                      </vs-td>
                      <vs-td colspan="3" class="img-container pl-3">
                        <vs-input class="mt-2 investment-input" type="text" v-model.lazy="tr.newInvestment"
                          v-money="tr.newInvestment !== null || tr.newInvestment === 0 || tr.newInvestment === '$0' ? money : null"
                          name="amount" v-validate="'required'" :min="1" autocomplete="off"
                          :placeholder="tr.minPlaceholder" />
                        <!-- botones para proyectos en fondeo -->
                        <vs-button id="run_simulation_btn" :data-projectid="tr.id" class="statement-btn" color="dark"
                          @click.stop="simulateInvestment(tr)">Simular</vs-button>
                        <vs-button v-if="canInvest && tr.maximum > 0" id="invest_btn" :data-projectid="tr.id"
                          class="statement-btn" :color="colors.green"
                          @click.stop="startInvestment(tr)">Invertir</vs-button>
                        <vs-button v-if="!canInvest || tr.maximum <= 0" :disabled="true" class="statement-btn"
                          :color="colors.grayBtn">Invertir</vs-button>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </vx-card>
    </template>
    <!-- SOLO MS -->
    <template v-else>
      <!-- CARD COMO INVERTIR -->
      <vx-card class="mb-6">
        <div class="vx-row">
          <div class="vx-col w-full">
            <h3>¿Cómo invertir en RedGirasol?</h3>
            <p class="mt-5">
              Para invertir en RedGirasol solo necesitas <b>abonar</b> a tu cuenta de inversión. Durante la noche, tu saldo se invertirá en el portafolio RedGirasol y comenzará a crecer a partir del día siguiente. <br><br>
              Si lo deseas, también puedes invertir manualmente al <b>comprar participación</b> de otros inversionistas que buscan liquidez o invertir en <b>nuevos proyectos</b> en fondeo, si están disponibles. 
            </p>
          </div>
        </div>
      </vx-card>
  
      <!-- CARD COMPRA DE PARTICIPACION -->
      <vx-card class="mb-6" v-if="InvestorRegisteredOnSecondaryMarket">
        <div class="vx-row">
          <div class="vx-col w-full">
            <h3>Compra de participación</h3>
            <p class="mt-5">Invierte en el <b>Portafolio RedGirasol</b> comprando participación a otros inversionistas que buscan liquidez.</p>
          </div>
          <div class="vx-col w-full">
            <div id="data-list-thumb-view" class="data-list-container mt-4">
              <vs-table class="mt-5" ref="table" @selected="onRowSelected" :data="portfoliosToInvest" pagination
                :max-items="itemsPerPage" noDataText="No hay oportunidades disponibles">
                <template slot="thead">
                  <vs-th class="bold" sort-key="name">Nombre</vs-th>
                  <vs-th class="bold" sort-key="type"><span class="center">TIPO DE INVERSIÓN</span></vs-th>
                  <vs-th class="bold" sort-key="anual_interest">Tasa</vs-th>
                  <vs-th class="bold">Plazo</vs-th>
                  <vs-th class="bold" sort-key="remaining">Monto disponible</vs-th>
                  <vs-th class="bold">Monto a invertir</vs-th>
                  <vs-th></vs-th>
                  <vs-th></vs-th>
                </template>
  
                <template slot-scope="{data}">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <div class="flex flex-wrap items-center flex-grow justify-start">
                          <p class="pl-3 bold">
                            <router-link v-if="tr.loan_type != 0" class="bold text-dark ml-1 inline-link"
                              :to="{ name: 'oportunidadInversion', params: { id: tr.id } }">
                              {{ tr.name }}
                            </router-link>
                            <span v-else class="text-dark">
                              {{ tr.name }}
                            </span>
                          </p>
                          <template v-if="tr.loan_type == 0">
                            <vx-tooltip color="dark" position="top"
                              :text="tr.investor_id == 1190 ? rgTooltipText : genericTooltipText">
                              <feather-icon class="mt-1 ml-2 cursor-pointer" icon="InfoIcon"
                                svgClasses="h-5 w-5 text-dark" />
                            </vx-tooltip>
                          </template>
                        </div>
                      </vs-td>
                      <vs-td class="center">
                        <vx-tooltip color="dark" position="top" :text="getLoanTypeStr(tr.loan_type, true)">
                          <img :src="getLoanTypeIcon(tr.loan_type)" style="width: 40px" alt="" class="center">
                        </vx-tooltip>
                      </vs-td>
                      <vs-td>
                        <template v-if="tr.loan_type == 0">
                          <vx-tooltip color="dark" position="top"
                            text="Rendimiento anualizado neto promedio de los últimos 12 meses, antes de impuestos.">
                            <div class="flex flex-wrap items-center flex-grow justify-start">
                              <p class="font-medium">{{ tr.anual_interest }}</p>
                              <feather-icon class="ml-2 cursor-pointer" icon="InfoIcon" svgClasses="h-5 w-5 text-dark" />
                            </div>
                          </vx-tooltip>
                        </template>
                        <p v-else class="font-medium">{{ tr.anual_interest }}</p>
                      </vs-td>
                      <vs-td>
                        <template v-if="tr.loan_type == 0">
                          <vx-tooltip color="dark" position="top"
                            :text="'Podrás retirar hasta ' + mxnFormat(maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam) + ' por día, sujeto a la liquidez disponible.'">
                            <div class="flex flex-wrap items-center flex-grow justify-start">
                              <p class="font-medium">{{ tr.months }}</p>
                              <feather-icon class="ml-2 cursor-pointer" icon="InfoIcon" svgClasses="h-5 w-5 text-dark" />
                            </div>
                          </vx-tooltip>
                        </template>
                        <p v-else class="font-medium">{{ tr.months }} Meses</p>
                      </vs-td>
                      <vs-td>
                        <p class="font-medium">{{ tr.remainingFormat }}</p>
                        <vs-progress :percent="Number(tr.progress)" color="success" class="shadow-md" />
                      </vs-td>
                      <vs-td colspan="3" class="img-container pl-3">
                        <vs-input class="mt-2 investment-input" type="text" v-model.lazy="tr.newInvestment"
                          v-money="tr.newInvestment !== null || tr.newInvestment === 0 || tr.newInvestment === '$0' ? money : null"
                          name="amount" v-validate="'required'" :min="1" autocomplete="off"
                          :placeholder="tr.minPlaceholder" />
                        <!-- botones para proyectos en fondeo -->
                        <template v-if="tr.loan_type != 0">
                          <vs-button id="run_simulation_btn" v-if="!InvestorRegisteredOnSecondaryMarket"
                            :data-projectid="tr.id" class="statement-btn" color="dark"
                            @click.stop="simulateInvestment(tr)">Simular</vs-button>
                          <vs-button v-if="canInvest && tr.maximum > 0" id="invest_btn" :data-projectid="tr.id"
                            class="statement-btn" :color="colors.green"
                            @click.stop="startInvestment(tr)">Invertir</vs-button>
                          <vs-button v-if="!canInvest || tr.maximum <= 0" :disabled="true" class="statement-btn"
                            :color="colors.grayBtn">Invertir</vs-button>
                        </template>
                        <!-- botones para MS -->
                        <template v-else>
                          <vs-button v-if="canInvest && tr.maximum > 0" id="invest_btn" :data-projectid="tr.id"
                            class="statement-btn" :color="colors.green"
                            @click.stop="startSmInvestment(tr)">Invertir</vs-button>
                          <vs-button v-if="!canInvest || tr.maximum <= 0" :disabled="true" class="statement-btn"
                            :color="colors.grayBtn">Invertir</vs-button>
                        </template>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </vx-card>
  
      <!-- CARD INVIERTE EN PROYECTOS -->
      <vx-card class="mb-6">
        <div class="vx-row">
          <div class="vx-col w-full">
            <h3>Invierte en proyectos de impacto</h3>
            <p class="mt-5">
              Elige los créditos en fondeo en los que deseas invertir.<br><br>
              Una vez que concluya el fondeo, tu inversión en estos nuevos proyectos se diversificará en el <b>Portafolio RedGirasol</b>.
            </p>
          </div>
          <div class="vx-col w-full">
            <div id="data-list-thumb-view" class="data-list-container mt-4">
              <vs-table class="mt-5" ref="table" @selected="onRowSelected" :data="projectsToInvest" pagination
                :max-items="itemsPerPage" noDataText="No hay oportunidades disponibles">
                <template slot="thead">
                  <vs-th class="bold" sort-key="name">Nombre</vs-th>
                  <vs-th class="bold" sort-key="type"><span class="center">TIPO DE INVERSIÓN</span></vs-th>
                  <vs-th class="bold" sort-key="anual_interest">Tasa</vs-th>
                  <vs-th class="bold">Plazo</vs-th>
                  <vs-th class="bold" sort-key="remaining">Monto disponible</vs-th>
                  <vs-th class="bold">Monto a invertir</vs-th>
                  <vs-th></vs-th>
                  <vs-th></vs-th>
                </template>
  
                <template slot-scope="{data}">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <div class="flex flex-wrap items-center flex-grow justify-start">
                          <p class="pl-3 bold">
                            <router-link v-if="tr.loan_type != 0" class="bold text-dark ml-1 inline-link"
                              :to="{ name: 'oportunidadInversion', params: { id: tr.id } }">
                              {{ tr.name }}
                            </router-link>
                            <span v-else class="text-dark">
                              {{ tr.name }}
                            </span>
                          </p>
                          <template v-if="tr.loan_type == 0">
                            <vx-tooltip color="dark" position="top"
                              :text="tr.investor_id == 1190 ? rgTooltipText : genericTooltipText">
                              <feather-icon class="mt-1 ml-2 cursor-pointer" icon="InfoIcon"
                                svgClasses="h-5 w-5 text-dark" />
                            </vx-tooltip>
                          </template>
                        </div>
                      </vs-td>
                      <vs-td class="center">
                        <vx-tooltip color="dark" position="top" :text="getLoanTypeStr(tr.loan_type, true)">
                          <img :src="getLoanTypeIcon(tr.loan_type)" style="width: 40px" alt="" class="center">
                        </vx-tooltip>
                      </vs-td>
                      <vs-td>
                        <template v-if="tr.loan_type == 0">
                          <vx-tooltip color="dark" position="top"
                            text="Rendimiento anualizado neto promedio de los últimos 12 meses, antes de impuestos.">
                            <div class="flex flex-wrap items-center flex-grow justify-start">
                              <p class="font-medium">{{ tr.anual_interest }}</p>
                              <feather-icon class="ml-2 cursor-pointer" icon="InfoIcon" svgClasses="h-5 w-5 text-dark" />
                            </div>
                          </vx-tooltip>
                        </template>
                        <p v-else class="font-medium">{{ tr.anual_interest }}</p>
                      </vs-td>
                      <vs-td>
                        <template v-if="tr.loan_type == 0">
                          <vx-tooltip color="dark" position="top"
                            :text="'Podrás retirar hasta ' + mxnFormat(maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam) + ' por día, sujeto a la liquidez disponible.'">
                            <div class="flex flex-wrap items-center flex-grow justify-start">
                              <p class="font-medium">{{ tr.months }}</p>
                              <feather-icon class="ml-2 cursor-pointer" icon="InfoIcon" svgClasses="h-5 w-5 text-dark" />
                            </div>
                          </vx-tooltip>
                        </template>
                        <p v-else class="font-medium">{{ tr.months }} Meses</p>
                      </vs-td>
                      <vs-td>
                        <p class="font-medium">{{ tr.remainingFormat }}</p>
                        <vs-progress :percent="Number(tr.progress)" color="success" class="shadow-md" />
                      </vs-td>
                      <vs-td colspan="3" class="img-container pl-3">
                        <vs-input class="mt-2 investment-input" type="text" v-model.lazy="tr.newInvestment"
                          v-money="tr.newInvestment !== null || tr.newInvestment === 0 || tr.newInvestment === '$0' ? money : null"
                          name="amount" v-validate="'required'" :min="1" autocomplete="off"
                          :placeholder="tr.minPlaceholder" />
                        <!-- botones para proyectos en fondeo -->
                        <template v-if="tr.loan_type != 0">
                          <vs-button id="run_simulation_btn" v-if="!InvestorRegisteredOnSecondaryMarket"
                            :data-projectid="tr.id" class="statement-btn" color="dark"
                            @click.stop="simulateInvestment(tr)">Simular</vs-button>
                          <vs-button v-if="canInvest && tr.maximum > 0" id="invest_btn" :data-projectid="tr.id"
                            class="statement-btn" :color="colors.green"
                            @click.stop="startInvestment(tr)">Invertir</vs-button>
                          <vs-button v-if="!canInvest || tr.maximum <= 0" :disabled="true" class="statement-btn"
                            :color="colors.grayBtn">Invertir</vs-button>
                        </template>
                        <!-- botones para MS -->
                        <template v-else>
                          <vs-button v-if="canInvest && tr.maximum > 0" id="invest_btn" :data-projectid="tr.id"
                            class="statement-btn" :color="colors.green"
                            @click.stop="startSmInvestment(tr)">Invertir</vs-button>
                          <vs-button v-if="!canInvest || tr.maximum <= 0" :disabled="true" class="statement-btn"
                            :color="colors.grayBtn">Invertir</vs-button>
                        </template>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </vx-card>
  
      <!-- CARD TIPOS DE INVERSION -->
      <vx-card>
        <div class="vx-row">
          <div class="vx-col w-full">
            <!-- iconos para tipos de credito -->
            <div class="flex flex-wrap items-center flex-grow justify-start">
              <div
                v-for="img in getLoanTypeIcon('all')"
                :key="img.id"
                class="mr-5"
                v-if="img.id !== 0 || InvestorRegisteredOnSecondaryMarket"
              >
                <img style="width: 40px;" :src="img.url" class="center" :alt="img.filename" />
                <small>{{ img.filename }}</small>
              </div>
            </div>
            <h5 class="mt-5 mb-2">Consideraciones</h5>
            <p>- El plazo de los proyectos semilla se presenta en años.</p>
            <p>- La calificación crediticia corresponde al nivel de riesgo de cada proyecto: Riesgo mínimo <b>(A)</b>,
              riesgo
              muy bajo <b>(B)</b>, riesgo bajo <b>(C)</b>, riesgo moderado <b>(D)</b>.</p>
            <p>- Si deseas saber más sobre cómo calificamos los proyectos da clic <router-link
                class="bold inline-link-primary text-primary" to="#"
                @click.native="goToProjectsQualificationBlog">aquí.</router-link>
            </p>
            <p>- Los montos económicos mencionados se expresan en moneda nacional.</p>
  
  
  
          </div>
        </div>
      </vx-card>
    </template>

    <vs-popup :active.sync="isInstructionsPopupActive" title="Monto no válido">
      <div class="pt-2 p-4">
        <h3 class="title-primary">¿Estás list@ para crecer tu dinero?</h3>
        <p class="mt-4">
          Para realizar la simulación con el proyecto
          <span class="bold">{{ currentOportunityName }}</span>,
          ingresa un monto mínimo de
          <span class="bold">{{ currentMinInvestment }}</span> o un monto máximo de
          <span class="bold">{{ currentMaxInvestmentSimulation }}</span> en el espacio correspondiente.
        </p>
      </div>
    </vs-popup>

    <vs-popup :active.sync="isInvalidInvestmentPopupActive" title="Monto no válido para inversión">
      <div class="pt-2 p-4">
        <h3 class="title-primary">¿Estás list@ para crecer tu dinero?</h3>
        <p class="mt-4">
          Para realizar una inversión en el {{ currentOportunity.type == "project" ? 'proyecto' : 'portafolio' }}
          <span class="bold">{{ currentOportunityName }}</span>,
          ingresa un monto mínimo de
          <span class="bold">{{ currentMinInvestment }}</span> o un monto máximo de
          <span class="bold">{{ currentMaxInvestment }}</span> en el espacio correspondiente.
        </p>
      </div>
    </vs-popup>

    <vs-popup class="mid-popup header-primary" :active.sync="isInvestmentPopupActive"
      title="Confirmación de Inversión.">
      <div class="pt-1 p-4">
        <h4 class="mb-2">¡Ya estás a un clic de invertir con impacto!</h4>
        <p>Confirma tu inversión y disfruta de los beneficios de la energía limpia.</p>

        <div class="vx-row mt-5">
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full">
            <p class="mb-1 pl-1">Nombre del proyecto</p>
            <p class="info-border-inline mb-6">{{ currentOportunityName }}</p>
          </div>
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full">
            <p class="mb-1 pl-1">Monto de inversión</p>
            <p class="info-border-inline mb-6">{{ explicitMoneyFormat(investmentData.amount) }}</p>
          </div>
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full">
            <p class="mb-1 pl-1">Bonos disponibles</p>
            <p class="info-border-inline mb-6">{{ explicitMoneyFormat(investmentData.availableBonus) }}</p>
          </div>
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full" v-if="investAllWithBonus">
            <p class="mb-1 pl-1">Bonos restantes</p>
            <p class="info-border-inline mb-6">{{ explicitMoneyFormat(investmentData.newBonus) }}</p>
          </div>
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full" v-if="!investAllWithBonus">
            <p class="mb-1 pl-1">Saldo a ser utilizado</p>
            <p class="info-border-inline mb-6">{{ explicitMoneyFormat(investmentData.balanceToUse) }}</p>
          </div>
          <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/2 w-full" v-if="!investAllWithBonus">
            <p class="mb-1 pl-1">Saldo resultante</p>
            <p class="info-border-inline mb-6">{{ explicitMoneyFormat(investmentData.newBalance) }}</p>
          </div>
        </div>
        <div class="flex">
          <vs-button class="mt-4" @click="check2fa">Confirmar</vs-button>
          <vs-button type="border" class="ml-6 mt-4" @click="cancelInvestment">Cancelar</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup class="extended-popup header-primary" :active.sync="isSumulationViewActive"
      title="Simulación de inversión" v-if="isSumulationViewActive">
      <investment-simulation :initial-investment="initialSimulationInvestment" :current-project="currentOportunity"
        :current-project-name="currentOportunityName" @on-simulation-updated="onSimulationUpdated" />
    </vs-popup>

    <vs-popup :active.sync="successDialogActive" title="Inversión exitosa." class="header-primary">
      <investment-success-dialog :current-project-id="currentOportunity.id" @on-action-1="goToInvestmentPlan"
        @on-action-2="finishInvestment" />
    </vs-popup>

    <vs-popup v-if="secondaryMarketCasesDialogActive" :active.sync="secondaryMarketCasesDialogActive"
      :title="secondaryMarketCasesTitle" class="header-primary">
      <div class="vx-row">
        <div class="vx-col w-full">
          <!-- caso sin contrato sin minimo de IE -->
          <template v-if="noContractNoMinSmDialogActive">
            <p>
              Para poder invertir en los portafolios diversificados, es necesario que mejores tu inversión.<br><br>
              Solo necesitas firmar tu nuevo contrato y abonar a tu cuenta hasta alcanzar el mínimo de inversión de
              {{ mxnFormat(minimumFixedInvestmentRequiredToSignUpSmMxn) }}.<br><br>
              Cuando hayas alcanzado el mínimo de inversión y firmado tu nuevo contrato, podrás participar en todas las
              oportunidades de inversión a partir del día siguiente.
            </p>
            <div class="flex flex-wrap items-center flex-grow justify-start mt-base">
              <sign-secondary-market-contract-btn class="mr-5"
                @on-signed="reloadPage()"></sign-secondary-market-contract-btn>
              <pay-funds-btn :button-type="'border'"></pay-funds-btn>
            </div>

          </template>
          <!-- caso sin contrato con minimo de IE -->
          <template v-if="noContractMinSmDialogActive">
            <p>
              Para poder invertir en los portafolios diversificados, es necesario que mejores tu inversión.<br><br>
              Solo necesitas firmar tu nuevo contrato y podrás acceder a todas las oportunidades de inversión a partir
              del
              día
              siguiente.
            </p>
            <div class="flex flex-wrap items-center flex-grow justify-start mt-base">
              <sign-secondary-market-contract-btn @on-signed="reloadPage()"></sign-secondary-market-contract-btn>
            </div>

          </template>
          <!-- caso con contrato sin minimo de IE -->
          <template v-if="contractNoMinSmDialogActive">
            <p>
              Para poder invertir en los portafolios diversificados, es necesario que mejores tu inversión.<br><br>
              Solo necesitas abonar a tu cuenta hasta alcanzar el mínimo de inversión de {{
                mxnFormat(minimumFixedInvestmentRequiredToSignUpSmMxn) }} y podrás acceder a todas
              las
              oportunidades de inversión a partir del día siguiente.
            </p>
            <div class="flex flex-wrap items-center flex-grow justify-start mt-base">
              <pay-funds-btn></pay-funds-btn>
            </div>
          </template>
          <!-- caso en espera de enrolamiento a MS -->
          <template v-if="secondaryMarketWaitingEnrollDialogActive">
            <p>
              Ya completaste el proceso para mejorar tu inversión.<br><br>
              A partir de mañana podrás invertir en este portafolio y disfrutar de todos los beneficios de tu nueva
              inversión.
            </p>
          </template>
        </div>
      </div>
    </vs-popup>

    <!-- Componente para segundo factor -->
    <two-factor-auth :user-id="UserId" button-id="2fa_activated_btn" :current-project-id="currentOportunity.id"
      custom-indication-message="Por favor ingresa los 6 dígitos de tu Segundo Factor de Autenticación para realizar la inversión."
      @on-code-validated="onAuth" @on-code-invalid="onAuthFailed" ref="twoFactorAuth" />

    <!-- Componente para obtener la geolocalización -->
    <rg-geolocator ref="rgGeolocator" />
  </div>
</template>

<script>
import { VMoney } from 'v-money'
import formatHelper from '@mixins/formatHelper';
import currencyHelper from '@mixins/currencyHelper';
import ComplianceBanner from "@components/compliance/ComplianceBanner";
import qualificationsHelper from '@mixins/qualificationsHelper';
import dateHelper from "@mixins/dateHelper";
import stpHelper from "@mixins/stpHelper";
import { investorColors } from "@mixins/investorColors";
import InvestmentSimulation from "@components/investor/opportunityTabs/InvestmentSimulation";
import InvestmentSuccessDialog from "@components/investor/opportunityTabs/InvestmentSuccessDialog";
import userComplianceHelper from "@/helpers/userComplianceHelper";
import userIdentityHelper from "@/helpers/userIdentityHelper";
import investorInfoHelper from "@/helpers/investorInfoHelper";
import TwoFactorAuth from "@components/2fa/TwoFactorAuth";
import auth2faHelper from "@mixins/auth2faHelper";
import InvestorPlanBanner from "@components/investor/plans/InvestorPlanBanner";
import PayFundsBtn from '@components/investor/widgets/PayFundsBtn.vue';
import SignSecondaryMarketContractBtn from '@components/investor/secondary-market/SignSecondaryMarketContractBtn.vue';
import defaultParametersHelper from '@mixins/defaultParametersHelper';

export default {
  mixins: [formatHelper, currencyHelper, qualificationsHelper, dateHelper, userComplianceHelper, userIdentityHelper, investorInfoHelper, stpHelper, auth2faHelper, defaultParametersHelper],
  directives: { money: VMoney },
  components: {
    InvestmentSimulation,
    InvestmentSuccessDialog,
    ComplianceBanner,
    TwoFactorAuth,
    InvestorPlanBanner,
    PayFundsBtn,
    SignSecondaryMarketContractBtn
  },
  data() {
    return {
      twoFactorAuthProvider: null,
      rgTooltipText: "El portafolio de RedGirasol está diversificado en cientos de créditos. Al comprar participación en este portafolio, RedGirasol obtiene liquidez para fondear nuevos créditos y comprar participación a los inversionistas que desean vender parte de su portafolio.",
      genericTooltipText: "Esta es una participación de un inversionista en el portafolio de RedGirasol y está diversificado en cientos de créditos.",
      // oportunities: [],
      projectsToInvest: [],
      portfoliosToInvest: [],
      userData: {
        balance: null,
        bonus: null,
      },
      itemsPerPage: 5,
      isMounted: false,
      instructionsPopupActive: false,
      invalidInvestmentPopupActive: false,
      investmentPopupActive: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false
      },
      currentOportunityName: null,
      currentMinInvestment: null,
      currentMaxInvestment: null,
      currentMaxInvestmentSimulation: null,
      currentOportunity: {},
      investAllWithBonus: false,
      investmentData: {
        amount: 0,
        availableBonus: 0,
        balanceToUse: 0,
        newBalance: 0,
        newBonus: 0,
      },
      factorEnabled: false,
      initialSimulationInvestment: 0,
      simulationPopupActive: false,
      successDialogActive: false,
      mainComplianceRequirements: 0,
      fixedInvestmentRemainingToSignupSm: 0,
      secondaryMarketCasesDialogActive: false,
      noContractNoMinSmDialogActive: false,
      noContractMinSmDialogActive: false,
      contractNoMinSmDialogActive: false,
      secondaryMarketWaitingEnrollDialogActive: false,
      maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam: 0,
      minimumFixedInvestmentRequiredToSignUpSmMxn: 0
    }
  },
  async beforeMount() {
    this.isMounted = false
    this.showLoading(true)
    await this.getOportunities();
    const params = await this.getPublicParams(['max_effective_investment_withdrawal_per_investor_per_day', 'minimum_fixed_investment_required_to_sign_up_sm_mxn']);
    this.maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam = params.max_effective_investment_withdrawal_per_investor_per_day;
    this.minimumFixedInvestmentRequiredToSignUpSmMxn = params.minimum_fixed_investment_required_to_sign_up_sm_mxn;
    this.factorEnabled = await this.getUser2FAStatus(this.UserId);
    this.isMounted = true
    this.showLoading(false)
  },
  computed: {
    secondaryMarketCasesTitle() {
      return this.secondaryMarketWaitingEnrollDialogActive ? "Pronto podrás invertir en este portafolio" : "Mejora tu inversión.";
    },
    canInvest() {
      return this.mainComplianceRequirements === 0;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    colors() {
      return investorColors;
    },
    isInstructionsPopupActive: {
      get() {
        return this.instructionsPopupActive;
      },
      set(val) {
        this.instructionsPopupActive = val;
      }
    },
    isInvalidInvestmentPopupActive: {
      get() {
        return this.invalidInvestmentPopupActive;
      },
      set(val) {
        this.invalidInvestmentPopupActive = val;
      }
    },
    isSumulationViewActive: {
      get() {
        return this.$store.state.isSimulationPopupActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_SIMULATION_POPUP_ACTIVE", val);
      }
    },
    isInvestmentPopupActive: {
      get() {
        return this.investmentPopupActive;
      },
      set(val) {
        this.investmentPopupActive = val;
      }
    },
  },
  methods: {
    // #region inversion MP
    async getProjectsToInvest() {
      try {
        const res = await axios.get('api/proyectos/oportunidades');
        this.projectsToInvest = this.setAndOrderProjects(res.data.all);
        this.userData = res.data.user;
      }
      catch (e) {
        this.warn(e);
      }
    },
    setAndOrderProjects(projects) {
      // ordenamiento
      let topProjects = projects.filter(f => f.public_top === 1);
      let bottomProjects = projects.filter(f => f.public_top !== 1);
      topProjects.sort((a, b) => (a.public_date < b.public_date) ? -1 : 1);
      bottomProjects.sort((a, b) => (a.public_date < b.public_date) ? -1 : 1);
      let sortedProjects = [];
      topProjects.forEach(f => sortedProjects.push(f));
      bottomProjects.forEach(f => sortedProjects.push(f));

      // ajuste y calculos
      sortedProjects.forEach(f => {
        f.type = "project";
        f.months = f.term;
        f.amountFormat = this.explicitMoneyFormat(f.financed_amount, 2);
        f.remaining = f.financed_amount - f.invested;
        f.remainingFormat = this.explicitMoneyFormat(f.remaining, 0);
        f.progress = this.currencyFormat((f.invested / f.financed_amount) * 100, 2);
        f.progressSort = Math.round((f.invested / f.financed_amount) * 100);
        f.minFormat = this.explicitMoneyFormat(f.minimum, 0);
        if (f.maximum >= f.remaining) {
          f.maxFormat = this.explicitMoneyFormat(f.remaining, 0);
        }
        else {
          f.maxFormat = this.explicitMoneyFormat(f.maximum, 0);
        }
        f.minPlaceholder = `min. ${f.minFormat} max. ${f.maxFormat}`;
        f.newInvestment = null;
      });
      //
      return sortedProjects;
    },
    async simulateInvestment(proj) {
      this.setCurrentOportunityVars(proj);
      const newInvAmount = this.unMoneyFormat(proj.newInvestment);
      const valid = !newInvAmount ? false : (newInvAmount >= proj.minimum && newInvAmount <= proj.remaining);
      if (!valid) {
        this.isInstructionsPopupActive = true;
        return;
      }
      this.initialSimulationInvestment = newInvAmount;
      this.isSumulationViewActive = true;
    },
    onSimulationUpdated(value) {
      /*console.log("updated to " + value);
      this.currentOportunity.newInvestment = null;
      this.$nextTick(() => {
        console.log("it is to " + value);
        this.currentOportunity.newInvestment = value;
      });*/
    },
    setInvestmentVars(amount) {
      const currentBonus = this.userData.bonus;
      this.investmentData.amount = amount;
      this.investmentData.availableBonus = currentBonus;
      this.investAllWithBonus = false;

      // establecer bonus
      let balanceToUse = 0;
      let bonusToUse = 0;
      if (currentBonus > 0) {
        if (currentBonus >= amount) {
          this.investAllWithBonus = true;
          balanceToUse = 0;
          bonusToUse = amount;
        }
        else {
          bonusToUse = currentBonus;
          balanceToUse = amount - bonusToUse;
        }
      }
      else {
        balanceToUse = amount;
      }
      this.investmentData.balanceToUse = balanceToUse;
      this.investmentData.newBalance = this.userData.balance - balanceToUse;
      this.investmentData.newBonus = currentBonus - bonusToUse;
    },
    async startInvestment(proj) {
      this.setCurrentOportunityVars(proj);
      const newInv = this.unMoneyFormat(proj.newInvestment);
      const valid = this.validateInvestmentAmount(proj, newInv);
      if (!valid) {
        this.isInvalidInvestmentPopupActive = true;
        return;
      }

      // calculo con bonus
      let balance = this.userData.balance;
      if (this.userData.bonus > 0) {
        balance += this.userData.bonus;
      }

      if (newInv > balance) {
        this.confirmationDialog(this.goToFunding, 'Saldo insuficiente', 'No cuentas con saldo suficiente para realizar la inversión.', 'Abonar');
        return;
      }
      this.setInvestmentVars(newInv);
      this.isInvestmentPopupActive = true;
    },
    async confirmInvestment(authCode) {
      let payload = {
        project_id: this.currentOportunity.id,
        amount: this.investmentData.amount,
        geolocation: this.CurrentGeolocationData,
        two_factor_code: authCode,
        two_factor_code_provider: this.twoFactorAuthProvider
      }
      this.showLoading(true, 'En proceso de inversión.');
      try {
        this.isInvestmentPopupActive = false;
        const res = await axios.post('/api/v2/investor/createNewInvestment', payload);
        await this.onInvestorGeneralDataUpdated();
        await this.getOportunities();
        this.factorEnabled = await this.getUser2FAStatus(this.UserId);
        this.successDialogActive = true;
      }
      catch (e) {
        this.investmentPopupActive = false;
        if (e.response && e.response.data) {
          this.errorNotifDialog('La inversión no se ha podido ejecutar', e.response.data.error);
        }
        else {
          this.errorNotifDialog('Ha ocurrido un error', 'Por favor intenta más tarde');
        }
      }
      this.showLoading(false);
    },
    async cancelInvestment() {
      this.isInvestmentPopupActive = false;
    },
    validateInvestmentAmount(oportunity, amount) {
      if (amount === null) {
        return false;
      }
      var maxAmount = oportunity.maximum;
      if (oportunity.maximum >= oportunity.remaining) {
        maxAmount = oportunity.remaining;
      }
      return amount >= oportunity.minimum && amount <= maxAmount;
    },
    finishInvestment() {
      this.successDialogActive = false;
    },
    // #endregion inversion MP
    // #region inversion MS
    async getSmOrders() {
      try {
        const res = await axios.get('api/secondary-market/orders');
        // this.oportunities = this.oportunities.concat(this.setAndOrderOrders(res.data.orders));
        this.portfoliosToInvest = this.setAndOrderOrders(res.data.orders);
        this.fixedInvestmentRemainingToSignupSm = res.data.fixed_investment_remaining_to_signup_sm;
      }
      catch (e) {
        this.warn(e);
      }
    },
    setAndOrderOrders(orders) {
      // let min = this.InvestorRegisteredOnSecondaryMarket ? 1 : 5000;
      let min = 1;
      // ajuste y calculos
      orders.forEach(f => {
        f.type = "order";
        f.name = f.investor_name;
        f.loan_type = 0;
        f.months = "Sin plazo forzoso";
        f.amountFormat = this.explicitMoneyFormat(f.amount_to_sell, 2);
        f.remaining = f.amount_selling;
        f.remainingFormat = this.explicitMoneyFormat(f.remaining, 0);
        f.maximum = f.amount_selling;
        f.minimum = min;
        f.progress = this.currencyFormat((f.amount_sold / f.amount_to_sell) * 100, 2);
        // f.progressSort = Math.round((f.invested / f.financed_amount) * 100);
        f.minFormat = this.explicitMoneyFormat(min, 0);
        if (f.maximum >= f.remaining) {
          f.maxFormat = this.explicitMoneyFormat(f.remaining, 0);
        }
        else {
          f.maxFormat = this.explicitMoneyFormat(f.maximum, 0);
        }
        f.minPlaceholder = `min. ${f.minFormat} max. ${f.maxFormat}`;
        f.newInvestment = null;
      });
      //
      return orders;
    },
    async startSmInvestment(order) {
      this.setCurrentOportunityVars(order);
      // se valida si el usuario ya tiene firmado el contrato y cumple con la IE minima
      if (!this.InvestorSecondaryMarketContractSigned) {
        if (this.fixedInvestmentRemainingToSignupSm <= 0) {
          // console.log("sin contrato con minimo");
          this.secondaryMarketCasesDialogActive = true;
          this.noContractMinSmDialogActive = true;
          return;
        } else {
          // console.log("sin contrato sin minimo");
          this.secondaryMarketCasesDialogActive = true;
          this.noContractNoMinSmDialogActive = true;
          return;
        }
      } else {
        if (this.fixedInvestmentRemainingToSignupSm > 0) {
          // console.log("con contrato sin minimo");
          this.secondaryMarketCasesDialogActive = true;
          this.contractNoMinSmDialogActive = true;
          return;
        }
      }

      // se revisa si el usuario ya está enrolado al MS
      if (!this.InvestorRegisteredOnSecondaryMarket) {
        this.secondaryMarketCasesDialogActive = true;
        this.secondaryMarketWaitingEnrollDialogActive = true;
        return;
      }

      let balance = this.userData.balance;
      const newInv = this.unMoneyFormat(order.newInvestment);
      const valid = this.validateInvestmentAmount(order, newInv);
      if (!valid) {
        this.isInvalidInvestmentPopupActive = true;
        return;
      }
      if (newInv > balance) {
        this.confirmationDialog(this.goToFunding, 'Saldo insuficiente', 'No cuentas con saldo suficiente para realizar la inversión.', 'Abonar');
        return;
      }

      // console.log("con contrato con minimo");
      await this.check2fa();
    },
    async confirmSmInvestment(authCode) {
      const newInv = this.unMoneyFormat(this.currentOportunity.newInvestment);
      const orderId = this.currentOportunity.id;
      let payload = {
        amount: newInv,
        geolocation: this.CurrentGeolocationData,
        order_id: orderId,
        two_factor_code: authCode,
        two_factor_code_provider: this.twoFactorAuthProvider
      }
      this.showLoading(true, 'En proceso de inversión.');
      try {
        const res = await axios.post('/api/v2/investor/start-sm-investment-specific-order', payload);
        await this.getOportunities();
        this.successNotifDialog('Operación exitosa', 'La inversión ha sido realizada exitosamente, la verás reflejada en unos minutos.');
      }
      catch (e) {
        if (e.response && e.response.data) {
          this.errorNotifDialog('La inversión no se ha podido ejecutar', e.response.data.error);
        }
        else {
          this.errorNotifDialog('Ha ocurrido un error', 'Por favor intenta más tarde');
        }
      }
      this.showLoading(false);
    },
    // #endregion inversion MS
    // #region 2FA
    async check2fa() {
      if (!this.factorEnabled) {
        this.isInvestmentPopupActive = false;
        this.$vs.dialog({
          color: "warning",
          type: "confirm",
          title: "Autenticación necesaria",
          text: "Para realizar esta operación es necesario habilitar tu Segundo Factor de Autenticación.",
          acceptText: "Habilitar",
          cancelText: 'Cancelar',
          accept: this.goTo2FaPage,
        });
        return;
      }
      this.request2faCode();
    },
    async goTo2FaPage() {
      await this.$router.push({ name: 'auth2FaInversionista' });
    },
    request2faCode() {
      // se pide la geolocalizacion para la operacion
      this.$refs.rgGeolocator.askForGeolocation();
      this.isInvestmentPopupActive = false;
      this.$store.commit("TOGGLE_IS_2FA_POPUP_ACTIVE", true);
    },
    async onAuth(code) {
      this.twoFactorAuthProvider = this.$refs.twoFactorAuth.provider;
      if (this.currentOportunity.type == "project") {
        await this.confirmInvestment(code);
      } else {
        if (this.currentOportunity.type == "order") {
          await this.confirmSmInvestment(code);
        }
      }
    },
    async onAuthFailed(code) {
    },
    // #endregion 2FA
    async goToFunding() {
      await this.$router.push({ name: 'abonarFondos' });
    },
    setCurrentOportunityVars(oportunity) {
      this.currentOportunity = oportunity;
      this.currentOportunityName = oportunity.name;
      this.currentMinInvestment = oportunity.minFormat;
      this.currentMaxInvestment = oportunity.maxFormat;
      this.currentMaxInvestmentSimulation = oportunity.remainingFormat;
    },
    async getOportunities() {
      await this.getProjectsToInvest();
      // se listan las ordenes del MS solo si el inversionista ya pertenece al MS
      if (this.InvestorRegisteredOnSecondaryMarket) {
        await this.getSmOrders();
      }
    },
    async onRowSelected(tr) {
      //await this.$router.push({name: 'oportunidadInversion', params: {id: tr.id}});
    },
    async goToInvestmentPlan() {
      this.successDialogActive = false;
      await this.$router.push({ name: 'planesInversion' });
    },
    loadedRequirements(count) {
      this.mainComplianceRequirements = count;
    },
    reloadPage() {
      this.$router.go();
    }
  }
}
</script>


<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }

          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .investment-input {
              max-width: 250px;
            }
          }

        }

        td.td-check {
          padding: 20px !important;
        }

        .statement-btn {
          padding: 0.8rem 1rem;
          margin-left: 1rem;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
